/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonDetails({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PersonDetails"
  
}) {
let leadMetadataPersonFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.firstName',
})
let leadMetadataPersonLastnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.lastName',
})
let leadMetadataPersonBirthdateValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'metadata.person.birthDate',
format: fromFormat.dateISOIn,
})
let leadMetadataPersonEmailValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.email',
})
let leadMetadataPersonPhonedetailsNumberValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.number',
})
let constantData = ' ('
let leadMetadataPersonPhonedetailsTypeValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.type',
})
let constantData1 = ')'
let aggregateData = fromHelpers.joinPhone(leadMetadataPersonPhonedetailsNumberValueData, constantData, leadMetadataPersonPhonedetailsTypeValueData, constantData1)
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="First Name"
 data="lead.metadata.person.firstName"
 value={leadMetadataPersonFirstnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Last Name"
 data="lead.metadata.person.lastName"
 value={leadMetadataPersonLastnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Date of Birth"
 data="lead.metadata.person.birthDate"
 format="/Data/format.js dateISOIn"
 value={leadMetadataPersonBirthdateValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Email"
 data="lead.metadata.person.email"
 value={leadMetadataPersonEmailValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Phone"
 data="lead.metadata.person.phoneDetails.number"
 data="' ('"
 data="lead.metadata.person.phoneDetails.type"
 data="')'"
 aggregate="helpers.js joinPhone"
 value={aggregateData}
/>
{children}
</React.Fragment>)
}